import { render, staticRenderFns } from "./RiskScoreHistoryWidget.vue?vue&type=template&id=6637c356&scoped=true"
import script from "./RiskScoreHistoryWidget.vue?vue&type=script&lang=js"
export * from "./RiskScoreHistoryWidget.vue?vue&type=script&lang=js"
import style0 from "./RiskScoreHistoryWidget.vue?vue&type=style&index=0&id=6637c356&prod&lang=scss&scoped=true"
import style1 from "./RiskScoreHistoryWidget.vue?vue&type=style&index=1&id=6637c356&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6637c356",
  null
  
)

export default component.exports